import { trackCustomGA4Event } from "~/utilities/trackCustomEvent";

const trackNavigationEvent = (
    hasDropdown,
    level,
    path,
    isDesktopNav = true,
) => {
    trackCustomGA4Event("navigationClick", {
        click_type: hasDropdown ? "open_dropdown" : "navigate",
        level,
        path,
        navigation_type: isDesktopNav ? "desktop" : "mobile",
    });
};

export default trackNavigationEvent;
